export default __webpack_public_path__ + "static/media/process-download.2fbdd116.svg";